export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14604.0134303e.jpg";